import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";

const CanvasPinText = () => {
  const canvasphoto = useRef(null);

  const [pintext, setPintext] = useState();
  const [pinclientX, setPinclientX] = useState(0);
  const [pinclientY, setPinclientY] = useState(0);

  useEffect(() => {
    let canvas = canvasphoto.current;
    canvas.width = 350;
    canvas.height = 630;
  }, []);

  function getPos(e) {
    setPinclientX(e.touches[0].clientX);
    setPinclientY(e.touches[0].clientY);
    setTimeout(() => {
      showinputboxModal(e.touches[0].clientY, e.touches[0].clientX);
    }, 200);
  }

  function showinputboxModal(top, left) {
    let domId = (id) => {
      return document.getElementById(id);
    };

    console.log("this x->", top, "this y->", left);

    if (left > 235) {
      console.log("right");
      domId("modleInput").style.display = "block";
      domId("txtbox-pin").style.top = `${top}px`;
      domId("txtbox-pin").style.right = `50px`;
    } else {
      domId("modleInput").style.display = "block";
      domId("txtbox-pin").style.top = `${top}px`;
      domId("txtbox-pin").style.left = `${left}px`;
    }

    // domId("modleInput").style.display = "block";
    // domId("txtbox-pin").style.top = `${top}px`;
    // domId("txtbox-pin").style.left = `${left}px`;
  }

  function handleSetPin(text, x, y) {
    let localPintext = JSON.parse(localStorage.getItem("pintext"));
    let objectset = {
      valuetext: text,
      clientX: x,
      clientY: y,
    };
    console.log("this is result about client =>", objectset);

    if (!localPintext) {
      console.log("setLocalstorage here");
      localStorage.setItem("pintext", JSON.stringify(objectset));
    } else {
      console.log("this have a localPin", localPintext);
      let arrLocalPin = [];
    }
  }

  window.onclick = (e) => {
    // console.log("this click a >", e.target);

    if (
      e.target ===
      document.getElementsByClassName("content-inmodaltextinput")[0]
    ) {
      let domId = (id) => {
        return document.getElementById(id);
      };
      Swal.fire({
        text: "ต้องการยกเลิกปักหมุดใช่ หรือ ไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#607d8b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          domId("modleInput").style.display = "none";
        }
      });
    }
  };

  function handleSwitchModePIN(mode) {
    let docId = (id) => {
      return document.getElementById(id);
    };
    switch (mode) {
      case "pin":
        docId("btn-gopin").style.display = "none";
        docId("thiscontentShowpin").style.display = "none";
        docId("btn-showpin").style.display = "block";
        break;
      case "showpin":
        docId("btn-showpin").style.display = "none";
        docId("btn-gopin").style.display = "block";
        docId("thiscontentShowpin").style.display = "block";
        break;
    }
  }

  return (
    <div className="canvas-text-pin-page">
      <div className="content-canvas-textpin">
        <div className="nav-canvas-tools">
          <button
            type="button"
            id={"btn-gopin"}
            onClick={() => {
              handleSwitchModePIN("pin");
            }}
          >
            วาดหมุด
          </button>
          <button
            type="button"
            id={"btn-showpin"}
            onClick={() => {
              handleSwitchModePIN("showpin");
            }}
          >
            เลือกหมุด
          </button>
        </div>
        <div className="canvas">
          <canvas
            className="canvasPhoto"
            ref={canvasphoto}
            onTouchStart={getPos}
          ></canvas>
          <div className="box-pin-content">
            <div className="this-pin-content" id={"thiscontentShowpin"}>
              <i className="bi-geo-alt" id={`pintest-0`}></i>
            </div>
          </div>
          <div className="modle-box-inputtext" id="modleInput">
            <div className="content-inmodaltextinput">
              <div className="box-textinput" id="txtbox-pin">
                <div className="input-text-boxmodal">
                  <div className="box-confirm-modalInput">
                    <i
                      className="bi-check-lg"
                      id="confirm-modal-boxinputtext"
                      onClick={() => {
                        Swal.fire({
                          text: "ต้องการปักหมุดใช่ หรือ ไม่",
                          icon: "info",
                          showCancelButton: true,
                          confirmButtonColor: "#607d8b",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "ตกลง",
                          cancelButtonText: "ยกเลิก",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            handleSetPin(pintext, pinclientX, pinclientY);
                          }
                        });
                      }}
                    ></i>
                  </div>
                  <div className="box-pin-modalInput">
                    <i className="bi-geo-alt-fill"></i>
                  </div>
                  <input
                    className="text-edit"
                    type="text"
                    onChange={(e) => {
                      setPintext(e.target.value);
                    }}
                    onFocus={(e) => {
                      e.target.select();
                    }}
                  ></input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CanvasPinText;
